var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4286 4.71436H0V17.2858H20.4286V4.71436Z",
    fill: "#BEDDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4291 4.71436H10.2148V17.2858H20.4291V4.71436Z",
    fill: "#93C7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4286 1.04761H0V5.23809H20.4286V1.04761Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14315 3.92863C3.57709 3.92863 3.92888 3.57685 3.92888 3.1429C3.92888 2.70896 3.57709 2.35718 3.14315 2.35718C2.7092 2.35718 2.35742 2.70896 2.35742 3.1429C2.35742 3.57685 2.7092 3.92863 3.14315 3.92863Z",
    fill: "#FF5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76229 3.92863C6.19623 3.92863 6.54802 3.57685 6.54802 3.1429C6.54802 2.70896 6.19623 2.35718 5.76229 2.35718C5.32834 2.35718 4.97656 2.70896 4.97656 3.1429C4.97656 3.57685 5.32834 3.92863 5.76229 3.92863Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38143 3.92863C8.81537 3.92863 9.16716 3.57685 9.16716 3.1429C9.16716 2.70896 8.81537 2.35718 8.38143 2.35718C7.94749 2.35718 7.5957 2.70896 7.5957 3.1429C7.5957 3.57685 7.94749 3.92863 8.38143 3.92863Z",
    fill: "#91DC5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16584 9.1665H3.92773V10.7379H9.16584V9.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16584 12.3093H3.92773V13.8807H9.16584V12.3093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 9.1665H11.2617V10.7379H16.4998V9.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5474 12.3093H11.2617V13.8807H17.5474V12.3093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5481 12.0476C15.093 12.0476 13.0957 14.045 13.0957 16.5C13.0957 18.955 15.0931 20.9524 17.5481 20.9524C20.0031 20.9524 22.0005 18.955 22.0005 16.5C22.0005 14.0449 20.0031 12.0476 17.5481 12.0476Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5469 20.9524C20.0019 20.9524 21.9993 18.955 21.9993 16.5C21.9993 14.0449 20.0019 12.0476 17.5469 12.0476",
    fill: "#FF5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3991 17.2407L18.6584 16.4999L19.3991 15.759L18.288 14.6479L17.5472 15.3887L16.8064 14.6479L15.6953 15.759L16.4361 16.4999L15.6953 17.2407L16.8064 18.3518L17.5472 17.611L18.288 18.3518L19.3991 17.2407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4291 1.04761H10.2148V5.23809H20.4291V1.04761Z",
    fill: "#003778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.ee9b7db89c3874cf3d8204cbf2769063.svg";
export { ForwardRef as ReactComponent };